import Vue from 'vue';
// import { NavigationGuard } from 'vue-router';
import multiguard from 'vue-router-multiguard';
import { IonicVueRouter } from '@ionic/vue';
import store from './store';

Vue.use(IonicVueRouter);

const privateRoute = function(to, from, next) {
  if (!store.state.user.isAuthenticated) {
    next({ name: 'login' });
  } else {
    next();
  }
};

const paidRoute = function(to, from, next) {
  if (!store.state.user.billDate) {
    next({ name: 'pricing' });
  } else {
    next();
  }
};

// const requiresTutorialRoute: NavigationGuard = function(to, from, next) {
//   // if (!store.state.user.hasSeenTutorial) {
//   // next({ name: 'tutorial' });
//   // } else {
//   next();
//   // }
// };

// base: process.env.BASE_URL,
export default new IonicVueRouter({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/filterpolicies',
      name: 'tutorial',
      component: () => import('@/views/Policies.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('@/views/Account.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/support',
      name: 'support',
      component: () => import('@/views/Support.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue')
      // beforeEnter: requiresTutorialRoute
    },
    // {
    //   path: '/signup',
    //   name: 'signup',
    //   component: () => import('@/views/Signup.vue')
    //   // beforeEnter: requiresTutorialRoute
    // },
    {
      path: '/addpolicy',
      name: 'addPolicy',
      component: () => import('@/views/NewPolicy.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/editpolicy',
      name: 'editPolicy',
      component: () => import('@/views/EditPolicy.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/addprofile',
      name: 'addProfile',
      component: () => import('@/views/NewProfile.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      name: 'editprofile',
      path: '/editprofile/:profileId',
      component: () => import('@/views/EditProfile.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/addnetwork',
      name: 'addNetwork',
      component: () => import('@/views/NewNetwork.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/updatenetworkpolicy',
      name: 'updatenetworkpolicy',
      component: () => import('@/views/Map.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/networks',
      name: 'networks',
      component: () => import('@/views/Networks.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/profiles',
      name: 'profiles',
      component: () => import('@/views/Profiles.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/payments',
      name: 'payments',
      component: () => import('@/views/Payments.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/paid',
      name: 'paid',
      component: () => import('@/views/Paid.vue'),
      beforeEnter: multiguard([privateRoute]),
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/views/Devices.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/home',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/pricing',
      name: 'pricing',
      component: () => import('@/views/Pricing.vue'),
      beforeEnter: multiguard([privateRoute]),
    },
    {
      name: 'network-detail',
      path: '/network',
      component: () => import('@/views/NetworkDetail.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      name: 'profile-detail',
      path: '/profile/:profileId',
      component: () => import('@/views/ProfileDetail.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/updatedevicepolicy',
      name: 'updatedevicepolicy',
      component: () => import('@/views/Device.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      path: '/updatedevicename',
      name: 'updatedevicename',
      component: () => import('@/views/DeviceName.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    {
      name: 'device-detail',
      path: '/device',
      component: () => import('@/views/DeviceDetail.vue'),
      beforeEnter: multiguard([privateRoute, paidRoute]),
    },
    // {
      // path: '/tabs',
      // component: () => import('@/views/Tabs.vue'),
      // children: [
      //   {
      //     path: 'schedule',
      //     name: 'schedule',
      //     components: { session: () => import('@/views/SessionList.vue') },
      //     beforeEnter: multiguard([privateRoute, paidRoute]),
      //   },
      //   {
      //     path: '/addnetwork',
      //     name: 'signup',
      //     component: () => import('@/views/NewNetwork.vue'),
      //     beforeEnter: multiguard([privateRoute, paidRoute]),
      //   },
        // {
        //   name: 'session-detail',
        //   path: 'schedule/session/:sessionId',
        //   components: { session: () => import('@/views/SessionDetail.vue') }
        // },

        // {
        //   path: 'speakers',
        //   name: 'speakers',
        //   components: {
        //     speaker: () => import('@/views/SpeakerList.vue')
        //   }
        // },
        // {
        //   path: 'speakers/speaker/:speakerId',
        //   name: 'speaker-detail',
        //   components: {
        //     speaker: () => import('@/views/SpeakerDetail.vue')
        //   }
        // },
        // {
        //   path: 'speakers/session/:sessionId',
        //   name: 'speaker-session-detail',
        //   components: { speaker: () => import('@/views/SessionDetail.vue') }
        // },
      //   {
      //     path: 'map',
      //     name: 'map',
      //     components: { map: () => import('@/views/Map.vue') }
      //   },
      //   {
      //     path: 'about',
      //     name: 'about',
      //     components: { about: () => import('@/views/About.vue') }
      //   }
      // ]
    // },
    { path: '/', redirect: '/login',  }
    

  ]
});
